    const cpfMask = (_value, noMask = false) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^\d]/g, '')
    if (!noMask) {
        if (value.length <= 6) {
            value = num.replace(/(\d{3})(\d{1,3})/g, '$1.$2')
        } else if (value.length <= 9) {
            value = num.replace(/(\d{3})(\d{3})(\d{1,3})/g, '$1.$2.$3')
        } else {
            value = num.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, '$1.$2.$3-$4')
        }
        return value
    }
    return num
}
const cnpjMask = (_value, noMask = false) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^\d]/g, '');
    if (!noMask) {
        if (value.length <= 5) {
            value = num.replace(/(\d{2})(\d{1,3})/g, '$1.$2')
        } else if (value.length <= 8) {
            value = num.replace(/(\d{2})(\d{3})(\d{1,3})/g, '$1.$2.$3')
        } else if (value.length <= 12) {
            value = num.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/g, '$1.$2.$3/$4')
        } else {
            value = num.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})(\d{1,2})/g, '$1.$2.$3/$4-$5')
        }
        return value
    }
    return num
}
const cpfcnpjMask = (_value = "", noMask = false) => {
    let value = _value != null ? _value : "";
    const num = value.replace(/[^\d]/g, '');
    if (!noMask) {
        const tamanho = num.length;
        if (tamanho <= 11) {
            value = cpfMask(num);
            return value;
        } else if (tamanho <= 14) {
            value = cnpjMask(num);
            return value;
        } else {
            return value.substr(0, 18);
        }
    }
    return num;
}
const celularMask = (_value, noMask = false) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^\d]/g, '')
    if (!noMask) {
        if (value.length <= 7) {
            value = num.replace(/(\d{1,2})(\d{1,5})/g, '($1)$2')
        } else {
            value = num.replace(/(\d{2})(\d{5})(\d{1,4})/g, '($1)$2-$3')
        }
        return value
    }
    return num
}
const telefoneMask = (_value, noMask = false) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^\d]/g, '')
    if (!noMask) {
        if (value.length <= 6) {
            value = num.replace(/(\d{1,2})(\d{1,4})/g, '($1)$2')
        } else {
            value = num.replace(/(\d{2})(\d{4})(\d{1,4})/g, '($1)$2-$3')
        }
        return value
    }
    return num
}
const cepMask = (_value, noMask = false) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^\d]/g, '')
    if (!noMask) {
        if (value.length <= 5) {
            value = num.replace(/(\d{1,5})/g, '$1')
        } else {
            value = num.replace(/(\d{5})(\d{1,3})/g, '$1-$2')
        }
        return value
    }
    return num
}
const horaMask = (_value, noMask = false) => {
    let value = _value ? _value : "00:00";
    const num = value.replace(/[^\d]/g, '')
    if (!noMask) {
        if (value.length <= 2) {
            value = num.replace(/(\d{1,2})/g, '$1')
        } else {
            value = num.replace(/(\d{2})(\d{1,2})/g, '$1:$2')
        }
        return value
    }
    return num
}
const floatMask = (_value) => {
    let value = _value ? _value : "0,00";
    value = value.toString();
    if (value.length == 1) {
        value = value + "00"
    }

    value = value.replace(/\D/g, '');
    if (value === '') {
        value = '0.00'
    }
    value = (parseFloat(value) / 100).toFixed(2) + '';

    value = value.replace(".", ",");

    value = value.replace(/(d)(d{3})(d{3}),/g, "$1.$2.$3,");

    value = value.replace(/(d)(d{3}),/g, "$1.$2,");

    value = value;

    return value
}
const numeroMask = (_value = "") => {

    let value = _value ? _value.toString() : "";
    if (value) {
        const v = value.replace(/\D/g, "")
        value = v
    }

    return value
}
const ufMask = (_value) => {
    let value = _value ? _value : "";
    const v = value.replace(/[^a-zA-Z]/g, '');
    value = v;
    return value;
}
const placaMask = (_value) => {
    let value = _value ? _value : "";
    const num = value.replace(/[^0-9a-zA-Z]/g, '');
    if (value.length <= 3) {
        value = num.replace(/(\w{1,3})/g, '$1');
    } else {
        value = num.replace(/(\w{3})(\w{1,4})/g, '$1-$2');
    }
    return value
}

export default { cpfMask, cnpjMask, cpfcnpjMask, celularMask, telefoneMask, cepMask, horaMask, floatMask, numeroMask, ufMask, placaMask }

